import {
  post,
  get,
  deletefn,
  putfun
} from './http.js'
export default {
  // 获取我的视频列表
  async getVideoList(params) {
    return await get('/user/micro', params)
  },

  // 创建合集
  async postCollection(data) {
    return await post('/user/micro-collection', data)
  },

  // 合集列表
  async getCollectionList(params) {
    return await get('/user/micro-collection', params)
  },

  // 合集详情
  async getCollectionDetail(id) {
    return await get(`/user/micro-collection/${id}`)
  },

  // 获取合集视频
  async getCollectionVideos(id,params) {
    return await get(`/user/micro-collection-videos/${id}`,params)
  },

  // 编辑合集
  async putCollection(data,id) {
    return await putfun(`/user/micro-collection/${id}`,data)
  },

  // 移除合集
  async deleteCollection(id) {
    return await deletefn(`/user/micro-collection/${id}`)
  },
}



// WEBPACK FOOTER //
// ./src/request/collection.js